import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { landingAssets } from '../landing-assets';
import { landingContent } from '../landing-content';
import { LandingEyebrow } from './LandingEyebrow';
import { SectionShell } from './SectionShell';

/**
 * Full-bleed texture band.
 *
 * The marketing CSS stacked two textures with `mix-blend-mode: screen`, which smeared the
 * copy into an unreadable blur. One texture plus a dark gradient keeps AA contrast.
 */
export function StoryBand() {
  const { story } = landingContent;

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        minHeight: { xs: 480, md: 640 },
      }}
    >
      <Image
        src={landingAssets.storyTexture}
        alt=""
        role="presentation"
        aria-hidden
        fill
        sizes="100vw"
        style={{ objectFit: 'cover' }}
      />
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(5,10,14,.9) 0%, rgba(5,10,14,.62) 55%, rgba(5,10,14,.45) 100%)',
        }}
      />
      <SectionShell component="div" sx={{ position: 'relative', zIndex: 2, py: { xs: 8, md: 12 } }}>
        <Box sx={{ maxWidth: 720 }}>
          <LandingEyebrow sx={{ color: '#fff' }}>{story.eyebrow}</LandingEyebrow>
          <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
            {story.title}
          </Typography>
          <Typography sx={{ color: '#e2e2e2', fontSize: '1.1rem' }}>{story.description}</Typography>
        </Box>
      </SectionShell>
    </Box>
  );
}
